/* "Free" attention-grabbing animated badge.
 * Usage: <FreeBadge /> or <FreeBadge size="sm" /> */
import { Sparkles } from "lucide-react";

export function FreeBadge({ size = "md", className = "" }) {
    const sizes = {
        sm: "text-[10px] px-2 py-0.5 gap-1",
        md: "text-[11px] px-2.5 py-1 gap-1.5",
        lg: "text-[13px] px-3 py-1.5 gap-1.5",
    };
    return (
        <span
            data-testid="free-badge"
            className={`inline-flex items-center font-bold uppercase tracking-wide rounded-full bg-gradient-to-r from-[#F57C00] to-[#FF9800] text-white shadow-[0_0_0_0_rgba(245,124,0,0.7)] animate-free-pulse ${sizes[size]} ${className}`}
        >
            <Sparkles className="h-3 w-3" />
            Free
        </span>
    );
}

/* Inject pulse keyframes once globally */
if (typeof document !== "undefined" && !document.getElementById("free-badge-style")) {
    const css = `
@keyframes free-pulse {
  0% { box-shadow: 0 0 0 0 rgba(245,124,0,0.55); }
  70% { box-shadow: 0 0 0 12px rgba(245,124,0,0); }
  100% { box-shadow: 0 0 0 0 rgba(245,124,0,0); }
}
.animate-free-pulse { animation: free-pulse 2s infinite; }
`;
    const style = document.createElement("style");
    style.id = "free-badge-style";
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
}
